import config from "@/config";
import http from "@/utils/request";

export default {
	talkCategory: {
		list: {
			url: `${config.API_URL}/admin/talk_category/getList`,
			name: "获取话术分类列表",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		treeList: {
			url: `${config.API_URL}/admin/talk_category/getTreeList`,
			name: "获取话术分类树状列表",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/talk_category/detail`,
			name: "获取话术分类详情",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		create: {
			url: `${config.API_URL}/admin/talk_category/create`,
			name: "创建话术分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/admin/talk_category/update`,
			name: "更新话术分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/talk_category/delete`,
			name: "删除话术分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		batchDelete: {
			url: `${config.API_URL}/admin/talk_category/batchDelete`,
			name: "批量删除话术分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
	talk: {
		list: {
			url: `${config.API_URL}/admin/talk/getList`,
			name: "获取话术列表",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/talk/detail`,
			name: "获取话术详情",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		create: {
			url: `${config.API_URL}/admin/talk/create`,
			name: "创建话术",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/admin/talk/update`,
			name: "更新话术",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/talk/delete`,
			name: "删除话术",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		batchDelete: {
			url: `${config.API_URL}/admin/talk/batchDelete`,
			name: "批量删除话术",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
};
